// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3psUv","importantInfo":"styles_importantInfo__1I70K"};